var parts = ['indicator'];
import { asMultiStyleConfig } from '../../../../utils/theme';
var baseStyle = {
  indicator: {
    borderRadius: '4px'
  }
};
export var StatusLabel = asMultiStyleConfig({
  parts,
  baseStyle
});